import { Switch, Route, Redirect } from 'react-router-dom';
import Header from '../Header';
import PrivateRoute from '../PrivateRoute';
import { usePageviewTracking } from '../../analytics/rudderstack/usePageviewTracking';

function InspiniaRouter({ routes = [] }) {
  usePageviewTracking();

  return routes && Array.isArray(routes) && routes.length ? (
    <div>
      <Switch>
        {routes.map(({ navbar = false, path, exact = false }, i) => {
          const content = navbar || !path ? <Header /> : null;
          if (!path) return <Route key={`${i}-comp-404`}>{content}</Route>;
          if (exact)
            return (
              <Route exact path={path} key={`${i}-route`}>
                {content}
              </Route>
            );
          return (
            <Route path={path} key={`${i}-route`}>
              {content}
            </Route>
          );
        })}
      </Switch>
      <Switch>
        {routes.map(
          (
            {
              exact = false,
              isPrivate = false,
              component,
              path,
              redirect = false,
            },
            i,
          ) => {
            if (!path) return <Route key={`${i}-page-404`}>{component}</Route>;
            const props = { path };
            if (exact) props.exact = true;
            if (redirect)
              return (
                <Route {...props} key={`${i}-redirect`}>
                  <Redirect to={redirect} />
                </Route>
              );
            if (isPrivate)
              return (
                <PrivateRoute {...props} key={`${i}-private`}>
                  {component}
                </PrivateRoute>
              );
            return (
              <Route {...props} key={`${i}-page-route`}>
                {component}
              </Route>
            );
          },
        )}
      </Switch>
    </div>
  ) : (
    <></>
  );
}

export default InspiniaRouter;
